<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        storedFilmCodes.length > 0 ? 'selected' : ''
      ]"
      @click="form.filmcode.showFilmCodeModal = true"
    >
      Filmkoder
    </button>
  
    <b-modal
      v-model="form.filmcode.showFilmCodeModal"
      size="xl"
      title="Välj filmkoder"
      @ok="saveFilmCodesToLocalStorage"
      @hidden="hideFilmCodesModal"
      @show="showModal"
    >
      <b-form-row>
        <b-col
          sm="8"
          class="borderright"
        >
          <div>
            <b-row>
              <b-col sm="8">
                <label
                  class="col-sm-12 p-0"
                >Byrå</label>
                <v-select
                  v-model="selectedBuyingAgency"
                  class="mb-3 col-sm-10 p-0"
                  :options="form.buyingAgencies"
                />
                <label
                  class="col-sm-12 p-0"
                >Annonsör</label>
                <v-select
                  v-model="selectedAdvertiser"
                  class="mb-3 col-sm-10 p-0"
                  :options="form.advertisers"
                />
                <label
                  class="col-sm-12 p-0"
                >Produkt</label>
                <v-select
                  v-model="selectedProduct"
                  class="mb-3 col-sm-10 p-0"
                  :options="form.products"
                />
              </b-col>
            </b-row>
            <b-col sm="12">
              <b-row class="align-items-center">
                <div class="col-sm-12 p-0 mb-3">
                  <b-button
                    class="mr-2 mt-2 mb-2"
                    variant="primary"
                    size="sm"
                    @click="searchFilmCodes"
                  >
                    Sök filmkoder
                  </b-button>
                </div>
                <div
                  v-if="filmCodeSearchResult.length > 0"
                  class="col-sm-2 px-0"
                >
                  <b-button
                    variant="success"
                    size="sm"
                    @click="saveCodesFromTable()"
                  >
                    Lägg till alla
                  </b-button>
                </div>
                <div
                  v-else-if="statusfilmcodes == 'empty_search'"
                  class="col-sm-6 mt-2 text-center"
                >
                  inget resultat
                </div>
                <div class="col-sm-10 px-0 d-flex align-items-center">
                  <span
                    :style="cssVars"
                    :class="{ filmcodeslengthcount: filmCodeSearchResult.length > 0 }"
                  />
                  <span
                    v-if="filmCodeSearchResult.length > 0"
                    class="ml-1"
                  >Rader</span>
                </div>
              </b-row>
              <b-row>
                <div
                  v-show="filmCodeSearchResult.length > 0"
                  class="filmCodeTableWrapper"
                >
                  <table class="table table-hover filmCodeTable table-sm">
                    <thead>
                      <tr>
                        <th scope="col" />
                        <th scope="col">
                          Filmkod
                        </th>
                        <th scope="col">
                          Byrå
                        </th>
                        <th scope="col">
                          Annonsör
                        </th>
                        <th scope="col">
                          Produkt
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(film, index) in filmCodeSearchResult"
                        :key="index"
                      >
                        <th>
                          <b-button
                            class="text-nowrap"
                            size="sm"
                            variant="success"
                            @click="tableClicked(film.filmCode)"
                          >
                            Lägg till
                          </b-button>
                        </th>
                        <td>{{ film.filmCode }}</td>
                        <td>{{ film.buyingAgency }}</td>
                        <td>{{ film.advertiser }}</td>
                        <td>{{ film.productName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-row>
            </b-col>
            <b-row />
          </div>
        </b-col>    
        
        <b-col
          sm="4"
          class="mb-2"
        >
          <div class="col-sm-12 mb-2">
            <label for="measurements-selection">Filmkod</label>
            <b-form-textarea
              v-model="inputFilmCode"
              :placeholder="'Skriv in filmkod(er)'"
              :rows="1"
              :max-rows="8"
            />
          </div>
          <div class="col-sm-12 mb-3">
            <b-button
              id="btnAddFilmCode"
              class="btn btn-success"
              type="button"
              size="sm"
              @click="addFilmCode"
            >
              Lägg till
            </b-button>
            <b-button
              v-if="filmCodeList.length > 1"
              variant="danger"
              size="sm"
              class="ml-2 mb-3"
              @click="removeFilmCodes()"
            >
              Ta bort alla
            </b-button>
          </div>
          <div class="selectedfilmcodesclass col-sm-12">
            <div
              v-for="(filmCode, index) in filmCodeList"
              :key="index"
              class="mb-1 align-items-center d-flex"
              style="height: 38px;"
            >
              <span class="align-self-center">{{ filmCode }}</span> 
              <button              
                class="btn btn-sm btn-danger ml-auto"
                type="button"
                @click="removeFilmCode(index)"
              >
                Ta bort
              </button>
            </div>
          </div>
        </b-col>
      </b-form-row> 
          
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button         
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Avbryt
        </b-button>
        <b-button
          size="sm"     
          variant="primary"
          @click="ok()"
        >
          Spara
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
  
  <script>
  import "vue-select/dist/vue-select.css";
  import { search } from '../../../assets/js/api.js';
  import vSelect from "vue-select";
  import { BFormTextarea } from 'bootstrap-vue'
  
  export default {
    name: "FilmCodeModal",
    components: {
      vSelect,
      BFormTextarea
    },
    props: {
      form: Object,
    },
    data() {
      return {
        statusfilmcodes: "no_search",
        selectedBuyingAgency: "",
        selectedAdvertiser: "",
        selectedProduct: "",
        filmCodeList: [],
        inputFilmCode : '',
        filmCodeSearchResult : []      
      };
    },
    computed: {
      cssVars() {
        return {
          "--filmCodes-length": this.filmCodeSearchResult.length
        };
      },
      storedFilmCodes(){
        this.$store.state.campaignApiBody.payload.filmcodes
        let storedFilmCodes = localStorage.getItem("savedFilmCodes")
          ? JSON.parse(localStorage.getItem("savedFilmCodes"))
          : [];
          return storedFilmCodes;
      }
    },
    created() {
      let storedFilmCodes = localStorage.getItem("savedFilmCodes")
          ? JSON.parse(localStorage.getItem("savedFilmCodes"))
          : [];
      this.$store.commit('campaignApiBody/updateFilmCodes', storedFilmCodes);
    },
    methods: {
      onKeyUp(event) {
        if (event.key === "Enter" && this.form.filmcode.showFilmCodeModal) {
            this.form.filmcode.showFilmCodeModal = false;
            this.saveFilmCodesToLocalStorage()      
        }
      },
      saveCodesFromTable(){
        let filmcodesInSearchResult = this.filmCodeSearchResult.map(element => {
          return element.filmCode;
        });
        this.filmCodeList = filmcodesInSearchResult;
      },
      removeFilmCode(index){
        this.filmCodeList.splice(index, 1);
      },
      removeFilmCodes(){
        this.filmCodeList = [];
      },
      tableClicked(filmcode)
      {     
        if (this.filmCodeList.includes(filmcode)) {
          this.$bvToast.toast("Filmkoden är redan tillagd", {
            title: "Varning",
            variant: "warning",
            solid: true,
            autoHideDelay: 3000
          });
          return;
        }
        if(filmcode)
          this.filmCodeList.push(filmcode)
      },
      addFilmCode(){
        if (this.inputFilmCode.length === 0) return;
  
        const filmCodeArray = this.inputFilmCode.split(/[\s,]+/);
  
        const updatedCodes = [...this.filmCodeList];
  
        const numCodes = filmCodeArray.length;
  
        for (let ip = 0; ip < numCodes; ip++) {
          if (updatedCodes.includes(filmCodeArray[ip].toUpperCase())) {
            this.$bvToast.toast(
              "Filmkoden " + `${filmCodeArray[ip]}` + " finns redan.",
              {
                title: "Varning",
                variant: "warning",
                solid: true,
                autoHideDelay: 3000
              }
            );
            return;
          }
        }
  
        filmCodeArray.forEach(element =>
          this.filmCodeList.push(element.toUpperCase())
        );
      },
      async searchFilmCodes(){
        let startDate = this.$store.state.campaignApiBody.payload.start_date;
        let endDate = this.$store.state.campaignApiBody.payload.end_date
          let filmcodeSearchObj = {
            advertiser : this.selectedAdvertiser ? this.selectedAdvertiser.id : null,
            buyingAgency : this.selectedBuyingAgency ? this.selectedBuyingAgency.id : null,
            product : this.selectedProduct ? this.selectedProduct.id : null,
            startDate,
            endDate
        }
  
        let filmcodes = await search("Spot/SpotSearch", filmcodeSearchObj)    
        this.statusfilmcodes =
          filmcodes.length == 0 ? "empty_search" : "not_empty_search";
        this.filmCodeSearchResult = filmcodes;
      },
      saveFilmCodesToLocalStorage() {
        this.$store.commit('campaignApiBody/updateFilmCodes', this.filmCodeList); 
        localStorage.setItem("savedFilmCodes", JSON.stringify(this.filmCodeList));    
      },
      hideFilmCodesModal(){
        document.removeEventListener("keyup", this.onKeyUp);
      },
      showModal() {
        document.addEventListener("keyup", this.onKeyUp);
        this.filmCodeList = [...this.storedFilmCodes]
      },
    }
  };
  </script>
  <style scoped>
  .filmCodeTableWrapper {
    height: 500px;
    overflow-y: clip;
  }
  .filmCodeTable {
    margin-top: 15px;
  }
  .borderright{
    border-right: 1px solid black;
  }
  tbody {
    display: block;
    height: 432px;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  thead,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  thead {
    width: calc(100% - 1em);
  }
  @property --num {
    syntax: "<integer>";
    initial-value: 0;
    inherits: false;
  }
  .filmcodeslengthcount {
    transition: --num 2s;
    counter-set: num var(--num);
    display: table-cell;
    vertical-align: middle;
  }
  .filmcodeslengthcount::after {
    content: counter(num);
  }
  .filmcodeslengthcount {
    --num: var(--filmCodes-length);
  }
  .selectedfilmcodesclass {
    max-height: 684px;
    overflow: auto;
  }
  </style>
  
  